'use strict';
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var SvgSource = function () {
    function SvgSource(options) {
        _classCallCheck(this, SvgSource);
        this.icons = options.icons;
        this.iconColor = options.iconsColor;
    }
    _createClass(SvgSource, [{
            key: 'get',
            value: function get(type) {
                return '<svg xmlns="http://www.w3.org/2000/svg" width="' + (this.icons[type][2] || '100%') + '" height="' + (this.icons[type][2] || '100%') + '" version="1.1" viewBox="' + this.icons[type][0] + '"><path class="dplayer-fill" style="fill:' + this.iconColor + '" d="' + this.icons[type][1] + '" id="dplayer-' + type + '"></path></svg>';
            }
        }]);
    return SvgSource;
}();
module.exports = SvgSource;


//////////////////
// WEBPACK FOOTER
// ./src/svg.js
// module id = 8
// module chunks = 0